import React from 'react';
import { Button } from '../ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';

export const ClickableKpiCard = ({
  title,
  value,
  hint,
  icon: Icon,
  onClick,
  cardClassName = '',
  iconWrapClassName = 'p-2 bg-primary/10 rounded-lg',
  iconClassName = 'h-4 w-4 text-primary',
  valueClassName = 'text-hr-h2 font-bold text-foreground',
}) => (
  <Card
    className={`cursor-pointer transition-all duration-200 hover:shadow-md hover:-translate-y-0.5 ${cardClassName}`}
    onClick={onClick}
  >
    <CardHeader className="pb-2">
      <CardTitle className="text-sm font-medium text-muted-foreground flex items-center gap-2">
        {Icon && (
          <div className={iconWrapClassName}>
            <Icon className={iconClassName} />
          </div>
        )}
        {title}
      </CardTitle>
    </CardHeader>
    <CardContent>
      <div className={valueClassName}>{value}</div>
      {hint ? <p className="text-xs text-muted-foreground mt-1">{hint}</p> : null}
    </CardContent>
  </Card>
);

export const KpiDetailPanel = ({
  detail,
  onClose,
  onOpenModule,
  className = 'border-primary/20 bg-primary/5',
}) => {
  if (!detail) return null;
  return (
    <Card className={className}>
      <CardHeader className="border-b border-border/50">
        <div className="flex items-center justify-between gap-3">
          <CardTitle>{detail.title} - Detailed Page</CardTitle>
          <div className="flex gap-2">
            <Button variant="outline" onClick={onClose}>Close</Button>
            <Button onClick={onOpenModule}>Open Module</Button>
          </div>
        </div>
      </CardHeader>
      <CardContent className="pt-4">
        <p className="text-hr-h2 font-bold">{detail.value}</p>
        <p className="text-hr-sm text-muted-foreground mt-2">{detail.description}</p>
      </CardContent>
    </Card>
  );
};

